"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1({ children }) {
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-white", css: {
            display: maxWidth768 ? 'flex' : 'grid',
            flexDirection: 'column',
            gridTemplateColumns: '240px auto',
            rowGap: '10px',
            padding: '20px 16px',
            '.required_wrapper': {
                display: 'flex',
                columnGap: '2px',
            },
        } }, { children: children })));
}
exports.default = default_1;
